import { t } from "i18next";

import type { TimeTrackingTypeId } from "~/modules/timeTracking/api/timeTrackingType/timeTrackingTypeTypes.ts";

export function getTimeTrackingTypeDisplayNameById(id: TimeTrackingTypeId): string {
	return t(`entities:timeTrackingTypes.${id}`);
}